/**
 * Detects if object is empty e.g. without properties
 * @param value The object to test
 */
export const isObjectEmpty = (value: object): boolean => Object.keys(value).length === 0;
